import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
	clearAdvanceFilter,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../../../../store/action/advanceFilter';
import { formatFilterName, getFiltersParams } from '../../../../../helper';
import { toast } from 'react-toastify';
import { changeDoctorStatus, deleteDoctor, getDoctorList } from '../../../../../services/doctors';
import { hasPermission } from '../../../../../utils/controller';

export default function useDoctor() {
	const [bulkAction, setBulkAction] = useState([]);
	const [isMarkAsStatus, setIsMarkAsStatus] = useState({
		isModelOpen: false,
		isStatus: null,
	});
	const [searchParams, setSearchParams] = useSearchParams();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [selectedDoctorListForDelete, setSelectedDoctorListForDelete] = useState([]);
	const [deselectRows, setDeselectRows] = useState(null);
	const [headerDropDown, setHeaderDropDown] = useState('All Doctors');
	const [sortDirection, setSortDirection] = useState({ credit_note_id: 'asc' });
	const suburl = localStorage.getItem('suburl');
	const dispatch = useDispatch();
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const [doctorsList, setDoctors] = useState({
		data: [],
		total_pages: 0,
		current_page: 1,
	});
	const [doctorsParams, setDoctorsParams] = useState({
		page: Number(searchParams.get("page")) || 1,
		page_size: Number(searchParams.get("page_size")) || 20,
		order_by: searchParams.get("order_by") || "created_at",
		sort_by: searchParams.get("sort_by") || "desc",
		filters: {},
	});
	const [isLoading, setLoading] = useState(false);
	const [isLoader, setLoader] = useState(false);
	const navigate = useNavigate();
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];

		if (key !== 'status') {
			const { doctors } = await getDoctorList({ ...doctorsParams, page_size: 1000 });

			selectInputData = doctors
				?.filter((doctor) => doctor[key])
				?.map((doctor) => ({
					key: doctor[key],
					value: doctor[key],
				}));
		} else {
			selectInputData = [
				{ key: 'Active Doctors', value: 'Active Doctors' },
				{ key: 'Inactive Doctors', value: 'Inactive Doctors' },
				{ key: 'Duplicate Doctors', value: 'Duplicate Doctors' },
			];
		}
		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) {
				return;
			}
			if (params.status) {
				setHeaderDropDown(params.status);
			}

			const updatedParams = { ...params };

			if (updatedParams.status === 'Active Doctors') {
				updatedParams.status = 1;
			}

			if (updatedParams.status === 'Inactive Doctors') {
				updatedParams.status = 2;
			}

			if (updatedParams.status === 'Draft Doctors') {
				updatedParams.status = 0;
			}

			if (updatedParams.status === 'Duplicate Doctors') {
				updatedParams.status = 4;
			}

			var { doctors, total_pages } = await getDoctorList({
				order_by: advanceFilterOrderby,
				sort_by: advanceFilterSortBy,
				page: advanceFilterPage,
				page_size: advanceFilterPageSize,
				filters: updatedParams,
			});

			const doctorList = mappedTableData(doctors);
			setBulkAction([]);

			setDoctors((prev) => ({
				...prev,
				data: doctorList,
				total_pages: total_pages,
				current_page: 1,
			}));

			dispatch(setAdvanceFilterTotalPage({ totalPages: total_pages }));
			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}

	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'Active Doctors', value: 'Active Doctors' },
					{ key: 'Inactive Doctors', value: 'Inactive Doctors' },
				];
			} else {
				const { doctors } = await getDoctorList({
					page_size: 1000,
					filters: {
						key: value,
					},
				});
				optionsList = doctors?.map((doctor) => ({
					key: doctor[key],
					value: doctor[key],
				}));
			}

			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	const onRowClick = (id) => {
		if (id && hasPermission('sales.doctors.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/doctors-details/${id}`);
		}
	};

	const FilterDatalist = (param, value, dropDownData) => {
		if (isAdvanceFilterApplied && dropDownData === 'All Doctors') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('All Doctors');
			return;
		}
		setHeaderDropDown(dropDownData);
		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'status') {
				return {
					...input,
					value: dropDownData,
				};
			}
			return input;
		});
		dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		const selectInputData = [
			{ key: 'Active Doctors', value: 'Active Doctors' },
			{ key: 'Inactive Doctors', value: 'Inactive Doctors' },
			{ key: 'Duplicate Doctors', value: 'Duplicate Doctors' },
		];
		dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.sort_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.sort_by]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ order_by: newDirection, sort_by: param.sort_by }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setDoctorsParams((prev) => ({
				...prev,
				order_by: newDirection,
				sort_by: param.sort_by,
			}));
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.id,
				'DOCTOR NAME': ele?.name,
				status: ele?.status,
				'BUSINESS NAME': ele?.business_name,
				EMAIL: ele?.email || 'N/A',
				MOBILE: ele?.mobile || 'N/A',
				'REGISTRATION NUMBER': ele?.registration_number,
			};
		});
	}

	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page }));
		} else {
			setDoctorsParams((prev) => ({
				...prev,
				page,
			}));
		}
	};

	const getModalContent = () => {
		return (
			<div>
				<p
					style={{ fontWeight: '600' }}
					className="ConfirmationText"
				>
					Are you sure you want to mark these {bulkAction.length} Doctors as{' '}
					{isMarkAsStatus.isStatus === 1 ? 'Active' : 'Inactive'}?
				</p>
				<div
					style={{
						padding: '0px 10px',
					}}
				>
					{doctorsList.data
						.filter((doctor) => bulkAction.includes(doctor.id))
						.map((doctor, index) => (
							<p key={doctor.id}>
								{index + 1}. {doctor['DOCTOR NAME']}
							</p>
						))}
				</div>
			</div>
		);
	};

	async function handleBulkDelete() {
		try {
			if (bulkAction.length === 0) {
				toast.error('Please select Doctor!');
				return;
			}
			var body = JSON.stringify({
				ids: bulkAction,
			});
			await deleteDoctor(body);
			toast.success('Doctors Deleted Successfully.');
			setIsDeleteModalOpen(false);
			setBulkAction([]);
			deselectRows && deselectRows();
			getDoctors();
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	function handleOpenBulkDeleteCustomerModal() {
		const selectedList = doctorsList.data?.reduce((acc, item) => {
			if (bulkAction.includes(item.id)) {
				acc.push(item['DOCTOR NAME']);
				return acc;
			}
			return acc;
		}, []);
		setSelectedDoctorListForDelete(selectedList);
		setIsDeleteModalOpen(true);
	}

	const triggerConfirmationModal = (status) => {
		setIsMarkAsStatus((prev) => ({
			isModelOpen: true,
			isStatus: status,
		}));
	};

	async function handleIsActiveStatus(status) {
		try {
			const formbody = {
				ids: bulkAction,
				status,
			};
			setLoader(true);

			await changeDoctorStatus(formbody);
			toast.success('Status Changes Successfully');
			setDoctorsParams((prev) => ({
				...prev,
				filterBy: 'status',
				filterValue: headerDropDown === 'All Docotors' ? null : status ? 0 : 1,
			}));
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader(false);
		}
	}

	const closeModal = () => {
		setIsMarkAsStatus((prev) => ({
			isModelOpen: false,
			isStatus: null,
		}));
	};

	const getDoctors = async () => {
		setLoading(true);
		var { doctors, total_pages, page } = await getDoctorList(doctorsParams);
		const doctorList = mappedTableData(doctors);
		setBulkAction([]);
		setDoctors((prev) => ({
			...prev,
			data: doctorList,
			total_pages: total_pages,
			current_page: page,
		}));
		setLoading(false);
	};


	const setHeaderDropdownStatus = (filters) => {
		const statusMap = {
			'0': 'Draft Doctors',
			'1': 'Active Doctors',
			'2': 'Inactive Doctors',
			'4': 'Duplicate Doctors',
		};
		if (filters.status !== undefined) {
			setHeaderDropDown(statusMap[filters.status]);
		}
	}

	const setFilterFromUrl = () => {
		const filters = {};
		searchParams.forEach((value, key) => {
			if (
				key !== "page" &&
				key !== "page_size" &&
				key !== "order_by" &&
				key !== "sort_by"
			) {
				filters[key] = value;
			}
		});
		setSortDirection({
			[searchParams.get("sort_by")]: searchParams.get("order_by") || "",
		});
		setHeaderDropdownStatus(filters);
		Object.entries(filters).forEach(([key, value]) => {
			const statusValueMap = {
				'0': 'Draft Doctors',
				'1': 'Active Doctors',
				'2': 'Inactive Doctors',
				'4': 'Duplicate Doctors',
			};
			const fieldValue =
				key === 'status'
					? statusValueMap[value]
					: value;
			dispatch(
				setSelectedInput({
					key: key,
					label: key === 'name' ? 'Doctor Name' : formatFilterName(key),
				})
			);
			dispatch(
				setSelectedInputValue({
					key: key,
					value: fieldValue,
				})
			);
			handleOnFocusSelectedFilterInput(key);
		});
		if (Object.keys(filters).length > 0) {
			dispatch(setAdvanceFilter({
				isAdvanceFilterApplied: true,
				page: Number(searchParams.get("page")) || 1,
				pageSize: Number(searchParams.get("page_size")) || 20,
				order_by: searchParams.get("order_by") || "created_at",
				sort_by: searchParams.get("sort_by") || "desc"
			}));
		} else {
			setDoctorsParams((prev) => ({
				...prev,
				filters
			}));
		}
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	function getParams(params) {
		const status = params.status;
		if (!status) return params;
		setHeaderDropDown(status);
		const statusMap = {
			'Draft Doctors': 0,
			'Active Doctors': 1,
			'Inactive Doctors': 2,
			'Duplicate Doctors': 4,
		};

		return {
			...params,
			status: statusMap[status],
		};
	}

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		// Normal params
		url.set("page", isAdvanceFilterApplied ? advanceFilterPage : doctorsParams.page);
		url.set("page_size", isAdvanceFilterApplied ? advanceFilterPageSize : doctorsParams.page_size);
		url.set(
			"order_by",
			isAdvanceFilterApplied ? advanceFilterOrderby : doctorsParams.order_by
		);
		url.set(
			"sort_by",
			isAdvanceFilterApplied ? advanceFilterSortBy : doctorsParams.sort_by
		);
		if (selectedInputs.length > 0) {
			const filters = getParams(getFiltersParams(selectedInputs));
			Object.entries(filters).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== '') {
					url.set(key, value);
				}
			});
		} else {
			Object.entries(doctorsParams.filters).forEach(([key, value]) => {
				url.set(key, value);
			});
		}
		setSearchParams(url);
	}

	useEffect(() => {
		setUrlSearchParams()
	}, [
		doctorsParams,
		selectedInputs,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterOrderby,
		advanceFilterSortBy,
		isAdvanceFilterApplied
	]);

	useEffect(() => {
		const stockFilterKeys = [
			'doctor_name',
			'business_name',
			'registration_name',
			'email',
			'mobile',
			'status'
		];
		const hasStockFilter = stockFilterKeys.some((key) => searchParams.has(key));
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			if (!hasStockFilter) {
				getDoctors();
			}
		}
	}, [searchParams, isAdvanceFilterApplied]);

	return {
		user,
		doctorsList,
		doctorsParams,
		suburl,
		handlePageChange,
		onRowClick,
		handleDeselectAll,
		FilterDatalist,
		sortDataList,
		sortDirection,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		advanceFilterTotalPages,
		advanceFilterPage,
		advanceFilterPageSize,
		searchSelectedInputItems,
		setIsAdvanceFilterOpen,
		isAdvanceFilterOpen,
		isAdvanceFilterApplied,
		selectedInputs,
		setBulkAction,
		bulkAction,
		triggerConfirmationModal,
		deselectRows,
		isLoading,
		isLoader,
		setHeaderDropDown,
		headerDropDown,
		dispatch,
		getModalContent,
		closeModal,
		isMarkAsStatus,
		handleIsActiveStatus,
		handleOpenBulkDeleteCustomerModal,
		isDeleteModalOpen,
		setIsDeleteModalOpen,
		selectedDoctorListForDelete,
		handleBulkDelete,
		setDoctorsParams,
	};
}
